import { ILoading } from 'src/commons/interfaces/screens.interface';
import { AppActionTypes, AppActions } from './app.actions';
export interface State {
    showSidenav: boolean;
    networkConnected: boolean;
    showSplashScreen: ILoading;
    showNavSplashScreen: boolean;
    showToast: boolean;
    toastMessage: string;
    showError: boolean;
    errorMessage: string;
}

const initialState: State = {
    showSidenav: false,
    networkConnected: false,
    showSplashScreen: {
        isLoading: true,
        loadingMessage: ''
    },
    showNavSplashScreen: true,
    showToast: false,
    toastMessage: '',
    showError: false,
    errorMessage: ''
};

export function reducer(state: State = initialState, action: AppActions): State {
    switch (action.type) {
        case AppActionTypes.CloseSidenav: {
            return {
                ...state,
                showSidenav: false
            };
        }

        case AppActionTypes.OpenSidenav: {
            return {
                ...state,
                showSidenav: true
            };
        }

        case AppActionTypes.UpdateNetworkConnectionStatus: {
            return {
                ...state,
                networkConnected: action.payload
            };
        }

        case AppActionTypes.UpdateSplashScreenStatus: {
            return {
                ...state,
                showSplashScreen: {
                    isLoading: action.isLoading,
                    loadingMessage: action.message
                }
            };
        }

        case AppActionTypes.UpdateNavSplashScreenStatus: {
            return {
                ...state,
                showNavSplashScreen: action.payload
            };
        }

        default: {
            return state;
        }
    }
}

export const getShowSidenav = (state: State) => state.showSidenav;
export const getNetworkConnectionStatus = (state: State) => state.networkConnected;
export const getSplashScreenStatus = (state: State) => state.showSplashScreen;
export const getNavSplashScreenStatus = (state: State) => state.showNavSplashScreen;

